import { Suspense } from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';

import OrderCutoffTimesTable from '@/components/restaurant/order-cutoff-times/order-cutoff-times-table';
import OrderCutoffTimesSkeleton from '@/components/restaurant/order-cutoff-times/order-cutoff-times-skeleton';

const OrderCutoffTimes = () => {
  const { t } = useTranslation();
  return (
    <>
      <Helmet>
        <title>{t('order-cutoff-times.title')}</title>
      </Helmet>
      <div className="flex items-center">
        <h1 className="text-lg font-semibold md:text-2xl">
          {t('order-cutoff-times.title')}
        </h1>
      </div>
      <Suspense fallback={<OrderCutoffTimesSkeleton />}>
        <OrderCutoffTimesTable />
      </Suspense>
    </>
  );
};

export default OrderCutoffTimes;
